import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", as }) => {
  const Tag = motion[as || "div"];
  return (
    <Tag
      className={className}
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </Tag>
  );
};

export const Eyebrow = ({ children, className = "" }) => (
  <span
    className={`inline-block text-xs sm:text-sm font-semibold tracking-[0.32em] uppercase text-[#6E6A66] ${className}`}
  >
    {children}
  </span>
);

export const SectionTitle = ({ children, className = "", tone = "fucsia" }) => (
  <h2
    className={`font-display uppercase ${
      tone === "gray" ? "text-[#6E6A66]" : "text-[#C20A78]"
    } text-5xl sm:text-6xl lg:text-7xl ${className}`}
  >
    {children}
  </h2>
);

export const BrandButton = ({ children, href, variant = "solid", testid, onClick }) => {
  const base =
    "inline-flex items-center justify-center rounded-full px-7 py-3.5 text-sm sm:text-base font-semibold tracking-wide transition-colors duration-300 cursor-pointer";
  const styles =
    variant === "outline"
      ? "border-2 border-[#C20A78] text-[#C20A78] hover:bg-[#C20A78] hover:text-white"
      : "bg-[#C20A78] text-white hover:bg-[#8F0759]";
  const cls = `${base} ${styles}`;
  if (href) {
    const external = href.startsWith("http") || href.startsWith("mailto");
    return (
      <a
        data-testid={testid}
        href={href}
        target={external ? "_blank" : undefined}
        rel={external ? "noopener noreferrer" : undefined}
        className={cls}
      >
        {children}
      </a>
    );
  }
  return (
    <button data-testid={testid} onClick={onClick} className={cls}>
      {children}
    </button>
  );
};

export const Placeholder = ({ className = "", label = "Imagen", ratio = "aspect-[3/4]" }) => (
  <div
    className={`relative ${ratio} w-full rounded-2xl bg-[#E6E0D4] border border-[#d8d1c2] overflow-hidden flex items-center justify-center ${className}`}
  >
    <div className="absolute inset-0 opacity-[0.12] bg-[repeating-linear-gradient(45deg,#141414_0_2px,transparent_2px_14px)]" />
    <span className="relative z-10 font-display text-xl tracking-wide text-[#8a8270] uppercase">
      {label}
    </span>
  </div>
);
